import u from "./general-validators/not-required-validator.js";
import k from "./general-validators/not-empty-validator.js";
import n from "./general-validators/email-validator.js";
import $ from "./general-validators/number-validator.js";
import h from "./general-validators/numeric-validator.js";
import w from "./general-validators/alphabetic-validator.js";
import v from "./general-validators/url-validator.js";
import g from "./general-validators/iban-validator.js";
import f from "./general-validators/date-validator.js";
import y from "./general-validators/age-validator.js";
import o from "./general-validators/phone-validator.js";
import b from "../phone-codes/phone-codes.js";
import C from "./countries-validators/ar.js";
import z from "./countries-validators/at.js";
import R from "./countries-validators/au.js";
import x from "./countries-validators/be.js";
import S from "./countries-validators/br.js";
import q from "./countries-validators/ca.js";
import E from "./countries-validators/ch.js";
import F from "./countries-validators/cl.js";
import N from "./countries-validators/co.js";
import W from "./countries-validators/cr.js";
import T from "./countries-validators/cz.js";
import L from "./countries-validators/de.js";
import Z from "./countries-validators/dk.js";
import j from "./countries-validators/ec.js";
import A from "./countries-validators/es.js";
import B from "./countries-validators/fi.js";
import D from "./countries-validators/fr.js";
import G from "./countries-validators/gb.js";
import H from "./countries-validators/gr.js";
import I from "./countries-validators/gt.js";
import J from "./countries-validators/hk.js";
import K from "./countries-validators/hu.js";
import M from "./countries-validators/id.js";
import O from "./countries-validators/ie.js";
import P from "./countries-validators/il.js";
import Q from "./countries-validators/in.js";
import U from "./countries-validators/it.js";
import X from "./countries-validators/jp.js";
import Y from "./countries-validators/kr.js";
import _ from "./countries-validators/lt.js";
import rr from "./countries-validators/lu.js";
import ar from "./countries-validators/mx.js";
import er from "./countries-validators/my.js";
import tr from "./countries-validators/nl.js";
import or from "./countries-validators/no.js";
import ir from "./countries-validators/nz.js";
import mr from "./countries-validators/pe.js";
import cr from "./countries-validators/ph.js";
import lr from "./countries-validators/pl.js";
import dr from "./countries-validators/pt.js";
import sr from "./countries-validators/ro.js";
import pr from "./countries-validators/se.js";
import nr from "./countries-validators/sg.js";
import fr from "./countries-validators/sv.js";
import br from "./countries-validators/th.js";
import Vr from "./countries-validators/tr.js";
import ur from "./countries-validators/tw.js";
import kr from "./countries-validators/us.js";
import $r from "./countries-validators/vn.js";
import hr from "./countries-validators/za.js";
import { useFormStore as wr } from "../../stores/form.js";
import { storeToRefs as vr } from "pinia";
const Wa = (a) => {
  let r;
  switch (a) {
    case "ar":
      r = C;
      break;
    case "at":
      r = z;
      break;
    case "au":
      r = R;
      break;
    case "be":
      r = x;
      break;
    case "br":
      r = S;
      break;
    case "ca":
      r = q;
      break;
    case "ch":
      r = E;
      break;
    case "cl":
      r = F;
      break;
    case "co":
      r = N;
      break;
    case "cr":
      r = W;
      break;
    case "cz":
      r = T;
      break;
    case "de":
      r = L;
      break;
    case "dk":
      r = Z;
      break;
    case "ec":
      r = j;
      break;
    case "es":
      r = A;
      break;
    case "fi":
      r = B;
      break;
    case "fr":
      r = D;
      break;
    case "gb":
      r = G;
      break;
    case "gr":
      r = H;
      break;
    case "gt":
      r = I;
      break;
    case "hk":
      r = J;
      break;
    case "hu":
      r = K;
      break;
    case "id":
      r = M;
      break;
    case "ie":
      r = O;
      break;
    case "il":
      r = P;
      break;
    case "in":
      r = Q;
      break;
    case "it":
      r = U;
      break;
    case "jp":
      r = X;
      break;
    case "kr":
      r = Y;
      break;
    case "lt":
      r = _;
      break;
    case "lu":
      r = rr;
      break;
    case "mx":
      r = ar;
      break;
    case "my":
      r = er;
      break;
    case "nl":
      r = tr;
      break;
    case "no":
      r = or;
      break;
    case "nz":
      r = ir;
      break;
    case "pe":
      r = mr;
      break;
    case "ph":
      r = cr;
      break;
    case "pl":
      r = lr;
      break;
    case "pt":
      r = dr;
      break;
    case "ro":
      r = sr;
      break;
    case "se":
      r = pr;
      break;
    case "sg":
      r = nr;
      break;
    case "sv":
      r = fr;
      break;
    case "th":
      r = br;
      break;
    case "tr":
      r = Vr;
      break;
    case "tw":
      r = ur;
      break;
    case "us":
      r = kr;
      break;
    case "vn":
      r = $r;
      break;
    case "za":
      r = hr;
      break;
  }
  return r;
}, Ta = (a, r, c = {}) => {
  String.prototype.allReplace = function(s) {
    let m = this;
    for (const p in s)
      m = m.replace(new RegExp(p, "g"), s[p]);
    return m;
  };
  const V = wr(), { countryCode: e, countryValidatorFile: i } = vr(V), l = ["cn", "myzh", "jp", "gr", "in", "il"].includes(e.value);
  a = a.allReplace({
    "０": "0",
    "１": "1",
    "２": "2",
    "３": "3",
    "４": "4",
    "５": "5",
    "６": "6",
    "７": "7",
    "８": "8",
    "９": "9",
    "。": ".",
    "｡": ".",
    "．": ".",
    "＠": "@"
  });
  const t = a.replace(/[^a-zA-Z0-9]/g, ""), d = a.trim();
  switch (r) {
    case "notRequired":
      return new u().validate();
    case "notEmpty":
      return new k().validate(a);
    case "email":
      return new n().validate(d, e, l);
    case "emailNotRequired":
      return a ? new n().validate(d, e, l) : !0;
    case "number":
      return new $().validate(a);
    case "numeric":
      return new h().validate(a, i.value.decimalSeparator);
    case "alphabeticExt":
      return new w().validate(a, e.value);
    case "url":
      return new v().validate(a);
    case "bankaccount":
    case "iban":
      return new g().validate(t);
    case "date":
      return new f().validate(a, 0, e.value);
    case "birthdate":
      return new f().validate(a, 18, e.value);
    case "age":
      return new y().validate(field, a);
    case "telephoneLibphonenumber":
      return new o().validate(t, e.value);
    case "telephoneLibphonenumberWithoutTrailingZero":
      return new o().validate("+" + b(e.value) + t, e.value);
    case "telephoneNotRequired":
      return a ? new o().validate(t, e.value) : !0;
    case "telephoneNotRequiredWithoutTrailingZero":
      return a ? new o().validate("+" + b(e.value) + t, e.value) : !0;
    case "zipcode":
      return i.value.zipcode(a);
    case "zipcodeNotRequired":
      return a ? i.value.zipcode(a) : !0;
    case "maxCharacters":
      return !(c.maxCharacters && a.length > c.maxCharacters);
  }
};
export {
  Wa as getCountryValidatorFile,
  Ta as validateValue
};
